import { Button, Col, DatePicker, Image, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import PhysioSessions from "./PhysioSessions";
import dayjs from "dayjs";
import calendarImg from "../../../../assets/images/nurseIcons/calender.svg";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./PhysioCare.css";
const dateFormat = "YYYY-MM-DD";

const PhysioCare = ({ patientData, refreshPage }) => {
  const curDate = dayjs().format(dateFormat);
  const [physioRefresh, setPhysioRefresh] = useState(false);
  const [date, setDate] = useState(curDate);
  const refreshTables = () => {
    setPhysioRefresh((prev) => !prev);
    // refreshPage();
  };
  function disabledDate(current) {
    return current && current > dayjs().endOf("day");
  }
  const onDateChange = (date, dateString) => {
    setDate(date ? dateString : null);
  };

  return (
    <div className="ip-physio-care">
      <Row gutter={[16, 16]}>
        <Col span={24} className="flex-end physio-care-date-toolbar">
          <Space>
            <Button
              type="text"
              className="ui-action-icon"
              onClick={() => {
                setDate((prev) =>
                  dayjs(prev).subtract(1, "day").format(dateFormat)
                );
              }}
              icon={<LeftOutlined />}
            />

            <DatePicker
              style={{
                color: "black",
                border: "1px solid #a182e3",
                height: "38px",
                width: "150px",
              }}
              value={dayjs(date)}
              disabledDate={disabledDate}
              className={inputStyles.mdDateInput}
              onChange={onDateChange}
              allowClear={false}
              suffixIcon={
                <Image width={20} src={calendarImg} preview={false} />
              }
            />
            <Button
              type="text"
              className="ui-action-icon"
              onClick={() =>
                setDate((prev) => dayjs(prev).add(1, "day").format(dateFormat))
              }
              icon={<RightOutlined />}
            />
          </Space>
        </Col>
        <Col span={24}>
          <PhysioSessions
            patientData={patientData}
            date={date}
            physioRefresh={physioRefresh}
            refreshTables={refreshTables}
            refreshPage={refreshPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PhysioCare;
